/**
 * Browser entry point — renders <App/> into #root.
 *
 * StrictMode is kept on; some Radix transitions look slightly different in
 * StrictMode dev because effects run twice — production behavior is fine.
 *
 * Logging is initialized before rendering so all components can log.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
import { getLogger } from "@/lib/logging";
import "@/styles/tailwind.css";

const logger = getLogger("opus.app");

const rootEl = document.getElementById("root");
if (!rootEl) {
  // Hard fail visibly — beats silently rendering nothing if the HTML is broken.
  throw new Error("#root element not found in index.html");
}

logger.info({ timestamp: new Date().toISOString() }, "app_startup_begin");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
